import { RouteProps } from 'react-router-dom'
import { AuthenticatedRoute } from './AuthenticatedRoute'

const LoggedInRoute = (props: RouteProps) => (
  <AuthenticatedRoute isAuthenticated={() => true} {...props} />
)

export default LoggedInRoute
